enum Statuses {
  Success = 'Success',
  Error = 'Error',
  Initial = 'Initial'
};

export default Statuses;
